import { Modal, TextContainer, Text, CardButton } from "@wayflyer/flyui";
import { useIntl } from "react-intl";
import { useState } from "react";
import { IconGridPlus24Line } from "@wayflyer/flyui-icons/24/line";

import { MESSAGES } from "../message-definitions";

interface SkipPlatformSelectionProps {
  onChange?: (value: boolean) => void;
  disabled?: boolean;
  selected?: boolean;
}

export const SkipPlatformSelectionModal = ({ onChange, disabled, selected }: SkipPlatformSelectionProps) => {
  const intl = useIntl();
  const [isOpen, setIsModalOpen] = useState(false);

  const handleContinue = () => {
    setIsModalOpen(false);
    onChange?.(true);
  };

  const handleCardClick = () => {
    if (selected) {
      onChange?.(false);
      return;
    }
    setIsModalOpen(true);
  };

  const handleClose = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Modal
        title={intl.formatMessage(MESSAGES.platformNotListedModalTitle)}
        tertiaryAction={{
          onAction: handleContinue,
          content: intl.formatMessage(MESSAGES.continueApplicationLabel),
        }}
        isOpen={isOpen}
        onClose={handleClose}
      >
        <TextContainer>
          <Text>
            {intl.formatMessage(MESSAGES.platformNotListedModalDescription, {
              br: () => (
                <>
                  <br /> <br />
                </>
              ),
            })}
          </Text>
        </TextContainer>
      </Modal>
      <CardButton
        value={intl.formatMessage(MESSAGES.platformNotListedModalTitle)}
        isSelected={selected}
        inputType="checkbox"
        onClick={handleCardClick}
        isDisabled={disabled}
      >
        <IconGridPlus24Line />
        <Text color={selected ? "default" : "placeholder"} lineHeight="none" align="center" size="xs">
          {intl.formatMessage(MESSAGES.platformNotListedModalTitle)}
        </Text>
      </CardButton>
    </>
  );
};
